import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";

export const WaHistory = ({ tick }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const load = () => api.get("/wa-broadcasts").then((r) => setItems(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 4000);
    return () => { clearInterval(t); };
  }, [tick]);
  return (
    <Card className="glass border-gold/20 p-4" data-testid="wa-history">
      <p className="font-serif font-semibold text-gold mb-2">Recent sends</p>
      {!items.length && <p className="text-sm text-emerald-100/50">Nothing sent yet.</p>}
      <div className="space-y-2">
        {items.map((b) => (
          <div key={b.id} className="rounded-lg border border-border/40 p-2.5 text-xs" data-testid={`wa-broadcast-${b.id}`}>
            <div className="flex justify-between gap-2">
              <span className="font-semibold">{b.label}</span>
              <span className="text-emerald-100/50">{new Date(b.created_at).toLocaleString()}</span>
            </div>
            <p className="text-emerald-100/70 truncate mt-0.5">{b.template_id ? `Template: ${b.template_id}` : b.message}</p>
            <p className="mt-1" data-testid={`wa-broadcast-status-${b.id}`}>
              <span className="text-[#25D366]">{b.sent} sent</span> · <span className="text-red-300">{b.failed} failed</span> · {b.total} total {b.done ? "· finished" : "· sending…"}
            </p>
            {b.failed > 0 && b.last_error && <p className="text-red-300/80 mt-0.5 truncate" title={b.last_error}>Last error: {b.last_error}</p>}
          </div>
        ))}
      </div>
    </Card>
  );
};
